import React, { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import IconMail from '../../component/icon/IconMail'
import IconLockDots from '../../component/icon/IconLockDots'
import IconUser from '../../component/icon/IconUser'
import axios from 'axios'
import BlankLayout from '../../component/layout/BlankLayout'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import Dropdown from '../../component/Dropdown'
import { languageList } from '../../util/helper'
import i18next from 'i18next'
import IconGlobe from '../../component/icon/IconGlobe'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Helmet } from 'react-helmet'
import { setCookie } from '../../helpers/cookies'


const RegisterNew = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const email = searchParams.get("email")
    const [loading, setLoading] = useState(false)

    const submitForm = async (values:any) => {
        if (!email || email.trim() === "") return toast.error(t('register.email_required'))
    
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/register`, {
            "email": email.trim(),
            "password": values.password,
            "confirm_password": values.password,
            "ic_number": values.ic,
            "name": values.username,
            "phone": values.mobileNumber,
            "role": "coach"
        }, { headers: {'Content-Type': 'application/json', "Accept":"application/json"}, withCredentials: true }).then( res => {
            setLoading(false)
            console.log("res", res)
            if (res.status == 200) {
                // login user
                localStorage.setItem("coach_user", JSON.stringify(res.data.data))
                localStorage.setItem("coach_token", res.data.token)
                setCookie("coach_token", res.data.token, 1);
                navigate("/")
            } else {
                toast.error("Error creating account")
            }
        }).catch( err => {
            setLoading(false)
            console.log("err register", err.response)
            // Try to extract a useful message from various possible error shapes
            const resp = err && err.response && err.response.data
            let message = "Error creating account"
            try {
                if (resp) {
                    if (typeof resp === 'string') {
                        message = resp
                    } else if (resp.error && typeof resp.error === 'string') {
                        message = resp.error
                    } else if (typeof resp === 'object') {
                        // resp might be like { phone: ["..."], email: [...] }
                        const parts: string[] = []
                        Object.values(resp).forEach((v: any) => {
                            if (Array.isArray(v)) parts.push(v.join(', '))
                            else if (typeof v === 'string') parts.push(v)
                            else parts.push(JSON.stringify(v))
                        })
                        if (parts.length > 0) message = parts.join(' / ')
                        else message = JSON.stringify(resp)
                    }
                }
            } catch (e) {
                console.log('Error parsing error response', e)
            }
            toast.error(message)
        })
    }



    const validationSchema = Yup.object().shape({
        username: Yup.string().required(t("validation.required")),
        ic: Yup.string().required(t("validation.required")),
            // .matches(/^\d{12}$/, t("validation.invalid_ic"))
            // .required(t("validation.required")),
        mobileNumber: Yup.string()
            .matches(/^\d{10,12}$/, t("validation.invalid_phone"))
            .required(t("validation.required")),
        password: Yup.string()
            .min(6, t("validation.password_min"))
            .required(t("validation.required")),
        terms: Yup.boolean()
            .oneOf([true], t("validation.accept_tnc"))
    })

    return (
        <>
        <Helmet>
            <title>Sign Up as Coach | MyKoku Platform Malaysia</title>
            <meta name="description" content="Create your free coach account on MyKoku. Manage students, track attendance, and schedule lessons – perfect for Malaysian tutors and coaching centers."/>
        </Helmet>
        <BlankLayout>
            <div className="relative flex min-h-screen items-center justify-center bg-cover bg-center bg-no-repeat px-6 py-10 dark:bg-[#060818] sm:px-16">
                <div className="relative w-full max-w-[870px] rounded-md bg-[linear-gradient(45deg,#fff9f9_0%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,_#fff9f9_100%)] p-2 dark:bg-[linear-gradient(52.22deg,#0E1726_0%,rgba(14,23,38,0)_18.66%,rgba(14,23,38,0)_51.04%,rgba(14,23,38,0)_80.07%,#0E1726_100%)]">
                    <div className="relative flex flex-col justify-center rounded-md backdrop-blur-lg dark:bg-black/50 px-6 lg:min-h-[758px] py-20">
                        <div className="mx-auto w-full max-w-[440px]">
                            <div className="mb-10">
                                <img className="w-20" src="/assets/images/koku.png" alt="logo"/>
                                <h1 className="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl">{t('register_new.register_new_account')}</h1>
                                <p className="text-base font-bold leading-normal text-white-dark">{t('register_new.enter_email_password')}</p>
                            </div>
                            <Formik
                                initialValues={{ username: "", ic: "", mobileNumber: "", password: "", terms: false}}
                                validationSchema={validationSchema}
                                onSubmit={(values) =>{
                                    submitForm(values)
                                }}
                            >
                                {({ isSubmitting, setFieldValue, handleBlur }) => (
                                <Form>
                                    <div className="space-y-5 dark:text-white">
                                        <div>
                                            <label>{t('register_new.name')}</label>
                                            <Field type="text" name="username" placeholder={t("register_new.enter_name")} className="form-input placeholder:text-white-dark"/>
                                            <ErrorMessage name="username" component="div" className="mt-1 text-red-500 text-sm" />
                                        </div>
                                        <div>
                                            <label>{t('register_new.ic')}</label>
                                            <Field type="text" name="ic" placeholder={t("register_new.enter_ic")} className="form-input placeholder:text-white-dark"
                                            onChange={(e:any) => {
                                                const alphanumericValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
                                                setFieldValue("ic", alphanumericValue, true)
                                            }}/>
                                            <ErrorMessage name="ic" component="div" className="mt-1 text-red-500 text-sm" />
                                        </div>
                                        <div>
                                            <label>{t('register_new.email')}</label>
                                            <input value={email || ""} disabled type="email" placeholder={t('register_new.enter_email')} className="form-input placeholder:text-white-dark" />
                                        </div>
                                        <div>
                                            <label>{t('register_new.mobile_number')}</label>
                                            <Field type="text" name="mobileNumber" placeholder={t("register_new.enter_mobile_number")} className="form-input placeholder:text-white-dark"
                                            onChange={(e:any) => {
                                                const numericValue = e.target.value.replace(/\D/g, '')
                                                setFieldValue("mobileNumber", numericValue, true)
                                            }}/>
                                            <ErrorMessage name="mobileNumber" component="div" className="mt-1 text-red-500 text-sm" />
                                        </div>
                                        <div>
                                            <label>{t('register_new.password')}</label>
                                            <Field type="password" name="password" placeholder={t("register_new.enter_password")} className="form-input placeholder:text-white-dark" />
                                            <ErrorMessage name="password" component="div" className="mt-1 text-red-500 text-sm" />
                                        </div>
                                        
                                        <div>
                                            <label className="flex items-start space-x-2 text-sm dark:text-white">
                                                <Field type="checkbox" name="terms" className="mt-1 w-4 h-4 text-theme focus:ring-theme rounded" />
                                                <span>
                                                    {t('register_new.agree_text')}{" "}
                                                    <a href="https://mykokurikulum.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-theme underline hover:text-theme/80 transition" >
                                                        {t('register_new.terms_and_conditions')}
                                                    </a>
                                                </span>
                                            </label>
                                            <ErrorMessage name="terms" component="div" className="mt-1 text-red-500 text-xs" />
                                        </div>


                                        <button type="submit" className="btn btn-primary rounded-3xl !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">
                                            {loading ? (<span className="animate-spin border-2 border-white dark:border-white !border-l-transparent rounded-full w-5 h-5 inline-flex"></span>) : t('register_new.register')}
                                        </button>
                                    </div>
                                </Form>
                                )}
                            </Formik>

                            <div className="relative my-7 text-center md:mb-9">
                                <span className="absolute inset-x-0 top-1/2 h-px w-full -translate-y-1/2 bg-white-light dark:bg-white-dark"></span>
                                <span className="relative bg-white px-2 font-bold uppercase text-white-dark dark:bg-dark dark:text-white-light">{t('register_new.or')}</span>
                            </div>
                            <div className="text-center dark:text-white">
                                {t('register_new.already_have_account')} &nbsp;
                                <Link to="/login" className="uppercase text-primary underline transition hover:text-black dark:hover:text-white">
                                    {t('register_new.sign_in')}
                                </Link>
                            </div>

                            <div>
                                <Dropdown placement={`bottom-start`} btnClassName=" p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60" button={<IconGlobe/>} >
                                    <ul className="p-2 text-dark dark:text-white-dark grid grid-cols-2 gap-2 font-semibold dark:text-white-light/90 w-[280px]">
                                        {languageList.map((item: any) => {
                                            return (
                                                <li key={item.code}>
                                                    <button
                                                        type="button"
                                                        className={`flex pt-2 w-full hover:text-primary rounded-lg ${i18next.language === item.code ? 'bg-primary/10 text-primary' : ''}`}
                                                        onClick={() => {
                                                            i18next.changeLanguage(item.code)
                                                            // setFlag(item.code);
                                                        }}
                                                    >
                                                        <img src={`/assets/images/flags/${item.code.toUpperCase()}.svg`} alt="flag" className="w-5 h-5 object-cover rounded-full" />
                                                        <span className="ltr:ml-3 rtl:mr-3">{item.name}</span>
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </Dropdown>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </BlankLayout>
        </>
    )
}

export default RegisterNew